"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'compLayout', 'skin'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, compLayout = _a.compLayout, skin = _a.skin;
    return {
        skin: skin || 'VideoDefault',
        videoId: compData.videoId,
        videoType: compData.videoType,
        showControls: compProps.showControls,
        autoplay: compProps.autoplay,
        loop: compProps.loop,
        showInfo: compProps.showinfo,
        youtubeConfig: {
            enablejsapi: compProps.enablejsapi,
            lightTheme: compProps.lightTheme,
        },
        facebookConfig: {
            width: compLayout.width + "px",
            height: compLayout.height + "px",
        },
    };
});
//# sourceMappingURL=VideoLegacy.js.map